// extracted by mini-css-extract-plugin
export var noOrders = "styles_noOrders__Luzuv";